import React, { useEffect } from "react";
import history from "../../history";
import { Row, Col, Card, CardBody } from "reactstrap";
import CartTitle from "../CartTitle";
import CustomButton from "../CustomButton";
import Loader from "../Loader";
import DesignCard from "../DesignCard";

import get from "lodash/get";

const _ = { get };

function appliedDetailPage(props) {
  let { elements } = props;

  useEffect(() => {
    props.handleFetchAppliedBranch("detail");
  }, []);

  const handleToUpdateForm = () => {
    history.push("/branch/apply-for-branch-update");
  };

  return (
    <React.Fragment>
      {props.appliedBranchStatus !== false ? <Loader /> : null}

      {props.appliedBranch.map((item) => (
        <div className="hideSearch">
          <Row>
            <Col sm={12}>
              <CartTitle
                iconClass={"hideexcel"}
                title={item.branchName}
                Name={"Search"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              <React.Fragment>
                <Row>
                  <Col md="12">
                    <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                      <span>
                        {_.get(
                          elements,
                          "branchDetailElements.subHeadingPersonalInformationElement",
                          "PERSONAL INFORMATION"
                        )}
                      </span>
                    </h2>
                  </Col>

                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.clubCoordinatorNameLabel",
                        "Club Coordinator Name"
                      )}
                      titleName={item.storeManagerName}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.emailLabel",
                        "Email"
                      )}
                      titleName={item.emailId}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.phoneNumberLabel",
                        "Phone Number"
                      )}
                      titleName={item.phone}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.alternatePhoneNumberLabel",
                        "Alternate Phone Number"
                      )}
                      titleName={item.altPhone}
                    />
                  </Col>
                 
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.countryLabel",
                        "Country"
                      )}
                      titleName={item.country}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.stateLabel",
                        "State"
                      )}
                      titleName={item.state}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.cityLabel",
                        "City"
                      )}
                      titleName={item.city}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.landmarkLabel",
                        "Landmark"
                      )}
                      titleName={item.landmark}
                    />
                  </Col>
                
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.pinCodeLabel",
                        "Pincode"
                      )}
                      titleName={item.pincode}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      cardClass={"textarea"}
                      name={_.get(
                        elements,
                        "branchDetailElements.addressLineOneLabel",
                        "Address Line 1"
                      )}
                      titleName={item.addressLine1}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      cardClass={"textarea"}
                      name={_.get(
                        elements,
                        "branchDetailElements.addressLineTwoLabel",
                        "Address Line 2"
                      )}
                      titleName={item.addressLine2}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      cardClass={"textarea"}
                      name={_.get(
                        elements,
                        "branchDetailElements.addressLineThreeLabel",
                        "Address Line 3"
                      )}
                      titleName={item.addressLine3}
                    />
                  </Col>
                
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.latitudeLabel",
                        "Latitude"
                      )}
                      titleName={item.latitude}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.longitudeLabel",
                        "Longitude"
                      )}
                      titleName={item.longitude}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.branchStatusLabel",
                        "Branch Status"
                      )}
                      titleName={item.branchStatus}
                    />
                  </Col>

                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.moderationStatusLabel",
                        "Moderation Status"
                      )}
                      titleName={item.moderationStatus}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <h2 className="title-bar secondary-title f-weight-bold themeColor my-3 pb-2">
                      <span>
                        {" "}
                        {_.get(
                          elements,
                          "branchDetailElements.subHeadingMainInformationElement",
                          "MAIN INFORMATION"
                        )}
                      </span>
                    </h2>
                  </Col>
                </Row>

                <Row>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.branchCodeLabel",
                        "Branch Code"
                      )}
                      titleName={item.branchCode}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.dealerWebUrlLabel",
                        "Dealer's Website URL"
                      )}
                      titleName={item.websiteUrl}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.weeklyOffLabel",
                        "Weekly Off"
                      )}
                      titleName={item.weeklyOff}
                    />
                  </Col>
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.businessHourLabel",
                        "Business Hours"
                      )}
                      titleName={item.businessHours}
                    />
                  </Col>
                
                  <Col md={3} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "branchDetailElements.Label",
                        ""
                      )}
                      titleName={item.branch}
                    />
                  </Col>
                </Row>

                <Col md="12">
                  <div className="d-flex justify-content-center justify-content-lg-end  position-relative my-3 ">
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "branchDetailElements.updateButtonElement",
                        "Update"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                      }
                      customClick={(e) => handleToUpdateForm(e)}
                    />
                  </div>
                </Col>
              </React.Fragment>
            </CardBody>
          </Card>
        </div>
      ))}
    </React.Fragment>
  );
}
export default appliedDetailPage;
